import React from 'react'

// @ts-ignore
import SlidingPanel from "react-sliding-side-panel"
// @ts-ignore
import Scrollbars from "react-custom-scrollbars-2"
import Classes from "classnames"
import {Accordion,AccordionDetails, AccordionSummary, IconButton} from "@mui/material"
import InfoParam from "../info/info-param"
import CloseIcon from "../../components/icons/close-icon"
import ExpandedIcon from "../../components/icons/expanded-icon"
import EditIcon from "../../components/icons/edit-icon"
import TrashIcon from "../../components/icons/trash-icon"

// const debug = "GroupPanel"
const debug = false

type Props = {}

type State = {
    items: any[] | null
}

export default class GroupPanel extends React.PureComponent<Props, State> {

    private panelId     : string
    private panelSize!  : number

    state: State = {
        items: null
    }

    constructor(props: Props) {
        super(props)

        this.panelId = 'group'
        this.updateSize(true)
    }

    componentDidMount() {
        window.bus.subscribe("group-panel:show", this, this.onShow)
        window.bus.subscribe("info-panel:show", this, this.onHide)
        window.bus.subscribe("info-panel:hide", this, this.onHide)
        window.bus.subscribe("panel:open", this, this.onPanelOpen)
        window.bus.subscribe("window-resize", this, this.updateSize)
    }

    componentWillUnmount() {
        window.bus.unsubscribe(this)
    }

    updateSize = (noUpdate = false) => {
        const panelSize = window.innerWidth > 700 ? 30 : 100

        if (this.panelSize !== panelSize) {
            this.panelSize = panelSize
            if (!noUpdate) {
                this.forceUpdate()
            }
        }
        return
    }

    onShow = (items: any[]) => {
        debug && console.log(debug, "onShow", items)
        this.setState({
            items: items
        })
        window.bus.triggerEvent("panel:open", this.panelId)
        return
    }

    onHide = () => {
        this.setState({
            items: null
        })
        return
    }

    onPanelOpen = (id: string) => {
        if (id !== this.panelId) {
            this.onHide()
        }
        return
    }

    // closing through info-panel:hide also deselects group markers radius
    onClose = () => {
        window.bus.triggerEvent("info-panel:hide")
        return
    }

    onEdit = (data: any) => {
        window.bus.triggerEvent("edit-point:show", data)
        this.onClose()
        return
    }

    onDelete = (data: any) => {
        window.bus.triggerEvent("delete-point", data.id)

        const items = _.without(this.state.items, data)
        if (_.isEmpty(items)) {
            this.onClose()
        } else {
            this.setState({
                items: items
            })
        }
        return
    }

    renderIcon = (data: any) => {
        // markerIcon is a getter building a new google Size on every access, read it once
        const icon = !data.isCustom && !data.triangulationType && _.get(data, 'markerIcon.icon')

        if (!icon) {
            return null
        }

        return (
            <img className="icon" src={icon.url || icon} alt={data.icon}/>
        )
    }

    render() {
        const classes = Classes("group-panel", {
            'mobile-device' : window.isMobileDevice
        })

        return (
            <SlidingPanel
                panelClassName  = "group-panel-container"
                type            = "right"
                noBackdrop
                isOpen          = {!!this.state.items}
                size            = {this.panelSize}
            >
                {!!this.state.items
                    ? <div className={classes}>
                        <div className="group-panel-title">
                            <div className="name">Точки в группе: {this.state.items.length}</div>
                            <IconButton
                                size    = "large"
                                color   = "default"
                                onClick = {this.onClose}
                            >
                                <CloseIcon/>
                            </IconButton>
                        </div>
                        <Scrollbars
                            className           = "group-panel-scroll"
                            autoHide
                            autoHideTimeout     = {1000}
                            autoHideDuration    = {200}
                        >
                            {_.map(this.state.items, (data: any, index: number) => {
                                return (
                                    <Accordion
                                        key             = {data.type + data.id}
                                        className       = "group-item"
                                        disableGutters
                                        elevation       = {0}
                                        TransitionProps = {{unmountOnExit: true}}
                                    >
                                        <AccordionSummary expandIcon={<ExpandedIcon/>}>
                                            <div className="group-item-title">
                                                <div className="index">{index + 1}.</div>
                                                {this.renderIcon(data)}
                                                <div className="name">{data.name}</div>
                                            </div>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            {_.map(data.infoPrams, (param: any, key: number) => {
                                                return (
                                                    <InfoParam
                                                        key     = {key}
                                                        data    = {param}
                                                    />
                                                )
                                            })}

                                            {data.isCustom &&
                                                <div className="edit-button" onClick={() => {
                                                    this.onEdit(data)
                                                    return
                                                }}>
                                                    <EditIcon className="edit-icon"/>
                                                    Редактировать
                                                </div>}

                                            {data.isCustom &&
                                                <div className="delete-button" onClick={() => {
                                                    this.onDelete(data)
                                                    return
                                                }}>
                                                    <TrashIcon className="delete-icon"/>
                                                    Удалить точку
                                                </div>}
                                        </AccordionDetails>
                                    </Accordion>
                                )
                            })}
                        </Scrollbars>
                    </div>
                    : null}
            </SlidingPanel>
        )
    }
}
